import API from '../../../../hooks/api';
import { userLoginData } from './ScreenHelper';

export const submitDataAPI = async (
        data: userLoginData,
        callBack: (success: boolean, errorMsg: string | null) => void = () => {}
    ) => {
    await API.post("/connect/merchant/password/reset/submit",  data)
    .then((res) => {
        res.data.result === "true" ? callBack(true, null) : callBack(false, res.data.result);
    }).catch((err) => {
        callBack(false, err);
    });
}
